export const Settings = {
    // Used on Safari
    mediaRecorderMimeType: 'audio/mp4; codecs="mp4a.40.2"',
    // Used on Chrome through Mp4MuxerWrapper
    audioEncoderCodec: 'opus',
    videoEncoderCodecs: [
        'hvc1.1.6.L93.90', // H.265/HEVC codec (widely supported)
        'avc1.4d0033', // H.264/AVC codec (widely supported)
        'avc1.420034',
    ],
    //videoEncoderCodec: 'avc1.420034',
    videoEncoderBitrateSd: 250_000, // broadcaster upload bw requirement 1Mbit/s
    videoEncoderBitrateHd: 1_500_000, // broadcaster upload bw requirement 6Mbit/s
    videoEncoderKeyFrameInterval: 30, // One keyframe per second at 30fps
    videoEncoderDefaultFrameRate: 30, // Changed to 30fps
    videoEncoderDefaultWidth: 1920, // Full HD width
    videoEncoderDefaultHeight: 1080, // Full HD height
    defaultHeartbeatInterval: 30000,
    viewerCounterUpdateInterval: 1000,
    viewerInfoInterval: 10000,
    audioSampleRate: 48000,
    audioNumberOfChannels: 1,
    audioCodec: 'opus',
    audioBitrate: 128000,
    audioFrameSize: 480,
    audioFrameDurationMicroseconds: 10000,
    audioPlayerRingBufferSizeInSamples: 480000, // 10 seconds of audio
    maxDelayOnTopOfOptimalDelayMillis: 30,
    maxFragmentSize: 64000, // 64KB - estimated size of protocol headers
    additionalSafetyDelayMillis: 100,
};
// Default video constraints we use when requesting media permissions with getUserMedia
export const DefaultVideoConstraints = {
    facingMode: { ideal: 'environment' }, // Request back camera by default
    width: { ideal: 1920 },
    height: { ideal: 1080 },
    frameRate: { ideal: 30 },
};
